module.exports = __webpack_public_path__ + "06_bob_brown.3bc97434.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/06_bob_brown.png
// module id = sip9
// module chunks = 0